import api from './axios';

export const getPayments = (params) => api.get('/payments', { params }).then(r => r.data);
const multipart = { headers: { 'Content-Type': undefined } };

export const createPayment = (data) => api.post('/payments', data, multipart).then(r => r.data);
export const updatePayment = (id, data) => api.post(`/payments/${id}`, data, multipart).then(r => r.data);
export const deletePayment = (id) => api.delete(`/payments/${id}`).then(r => r.data);
export const markPaymentPaid = (id, data) => api.post(`/payments/${id}/mark-paid`, data, multipart).then(r => r.data);
export const downloadPaymentReport = (params) =>
  api.get('/payments/report', { params, responseType: 'blob' }).then(r => r.data);
